let elements = [];

const update = ( contextDocument = document, viewport = null ) =>
{
	if ( null === viewport )
	{
		if ( typeof wmublocks === 'undefined' || ! wmublocks || ! wmublocks.viewportManager ) return;
		viewport = wmublocks.viewportManager.getCurrentViewport();
	}

	elements.forEach( ( element ) => element.style.height = undefined );
	elements = [];

	contextDocument.querySelectorAll( `[${viewport}-height^="homothety-"]` ).forEach( ( element ) =>
	{
		element.style.height = `calc(${element.clientWidth}px * var(--wmu-homothety-multiplier))`;
		elements.push( element );
	} );
};

export {
	update,
};